// STILL
import analysisDarkLarge from "./resources/imgs/still/analysis_dark_large.svg";
import analysisDarkSmall from "./resources/imgs/still/analysis_dark_small.svg";
import analysisDefaultLarge from "./resources/imgs/still/analysis_default_large.svg";
import analysisDefaultSmall from "./resources/imgs/still/analysis_default_small.svg";
import analysisLightLarge from "./resources/imgs/still/analysis_light_large.svg";
import analysisLightSmall from "./resources/imgs/still/analysis_light_small.svg";
import dataApiDarkLarge from "./resources/imgs/still/data-api_dark_large.svg";
import dataApiDarkSmall from "./resources/imgs/still/data-api_dark_small.svg";
import dataApiDefaultLarge from "./resources/imgs/still/data-api_default_large.svg";
import dataApiDefaultSmall from "./resources/imgs/still/data-api_default_small.svg";
import dataApiLightLarge from "./resources/imgs/still/data-api_light_large.svg";
import dataApiLightSmall from "./resources/imgs/still/data-api_light_small.svg";
import detectionDarkLarge from "./resources/imgs/still/detection_dark_large.svg";
import detectionDarkSmall from "./resources/imgs/still/detection_dark_small.svg";
import detectionDefaultLarge from "./resources/imgs/still/detection_default_large.svg";
import detectionDefaultSmall from "./resources/imgs/still/detection_default_small.svg";
import detectionLightLarge from "./resources/imgs/still/detection_light_large.svg";
import detectionLightSmall from "./resources/imgs/still/detection_light_small.svg";
import documentApiDarkLarge from "./resources/imgs/still/document-api_dark_large.svg";
import documentApiDarkSmall from "./resources/imgs/still/document-api_dark_small.svg";
import documentApiDefaultLarge from "./resources/imgs/still/document-api_default_large.svg";
import documentApiDefaultSmall from "./resources/imgs/still/document-api_default_small.svg";
import documentApiLightLarge from "./resources/imgs/still/document-api_light_large.svg";
import documentApiLightSmall from "./resources/imgs/still/document-api_light_small.svg";
import kopjraDarkLarge from "./resources/imgs/still/kopjra_dark_large.svg";
import kopjraDarkSmall from "./resources/imgs/still/kopjra_dark_small.svg";
import kopjraDefaultLarge from "./resources/imgs/still/kopjra_default_large.svg";
import kopjraDefaultSmall from "./resources/imgs/still/kopjra_default_small.svg";
import kopjraLightLarge from "./resources/imgs/still/kopjra_light_large.svg";
import kopjraLightSmall from "./resources/imgs/still/kopjra_light_small.svg";
import takedownDarkLarge from "./resources/imgs/still/takedown_dark_large.svg";
import takedownDarkSmall from "./resources/imgs/still/takedown_dark_small.svg";
import takedownDefaultLarge from "./resources/imgs/still/takedown_default_large.svg";
import takedownDefaultSmall from "./resources/imgs/still/takedown_default_small.svg";
import takedownLightLarge from "./resources/imgs/still/takedown_light_large.svg";
import takedownLightSmall from "./resources/imgs/still/takedown_light_small.svg";
import timestampApiDarkLarge from "./resources/imgs/still/timestamp-api_dark_large.svg";
import timestampApiDarkSmall from "./resources/imgs/still/timestamp-api_dark_small.svg";
import timestampApiDefaultLarge from "./resources/imgs/still/timestamp-api_default_large.svg";
import timestampApiDefaultSmall from "./resources/imgs/still/timestamp-api_default_small.svg";
import timestampApiLightLarge from "./resources/imgs/still/timestamp-api_light_large.svg";
import timestampApiLightSmall from "./resources/imgs/still/timestamp-api_light_small.svg";
import webForensicsDarkLarge from "./resources/imgs/still/web-forensics_dark_large.svg";
import webForensicsDarkSmall from "./resources/imgs/still/web-forensics_dark_small.svg";
import webForensicsDefaultLarge from "./resources/imgs/still/web-forensics_default_large.svg";
import webForensicsDefaultSmall from "./resources/imgs/still/web-forensics_default_small.svg";
import webForensicsLightLarge from "./resources/imgs/still/web-forensics_light_large.svg";
import webForensicsLightSmall from "./resources/imgs/still/web-forensics_light_small.svg";
import webIntelligenceDarkLarge from "./resources/imgs/still/web-intelligence_dark_large.svg";
import webIntelligenceDarkSmall from "./resources/imgs/still/web-intelligence_dark_small.svg";
import webIntelligenceDefaultLarge from "./resources/imgs/still/web-intelligence_default_large.svg";
import webIntelligenceDefaultSmall from "./resources/imgs/still/web-intelligence_default_small.svg";
import webIntelligenceLightLarge from "./resources/imgs/still/web-intelligence_light_large.svg";
import webIntelligenceLightSmall from "./resources/imgs/still/web-intelligence_light_small.svg";
import webSignDarkLarge from "./resources/imgs/still/web-sign_dark_large.svg";
import webSignDarkSmall from "./resources/imgs/still/web-sign_dark_small.svg";
import webSignDefaultLarge from "./resources/imgs/still/web-sign_default_large.svg";
import webSignDefaultSmall from "./resources/imgs/still/web-sign_default_small.svg";
import webSignLightLarge from "./resources/imgs/still/web-sign_light_large.svg";
import webSignLightSmall from "./resources/imgs/still/web-sign_light_small.svg";
import webTrustDarkLarge from "./resources/imgs/still/web-trust_dark_large.svg";
import webTrustDarkSmall from "./resources/imgs/still/web-trust_dark_small.svg";
import webTrustDefaultLarge from "./resources/imgs/still/web-trust_default_large.svg";
import webTrustDefaultSmall from "./resources/imgs/still/web-trust_default_small.svg";
import webTrustLightLarge from "./resources/imgs/still/web-trust_light_large.svg";
import webTrustLightSmall from "./resources/imgs/still/web-trust_light_small.svg";
import webpageApiDarkLarge from "./resources/imgs/still/webpage-api_dark_large.svg";
import webpageApiDarkSmall from "./resources/imgs/still/webpage-api_dark_small.svg";
import webpageApiDefaultLarge from "./resources/imgs/still/webpage-api_default_large.svg";
import webpageApiDefaultSmall from "./resources/imgs/still/webpage-api_default_small.svg";
import webpageApiLightLarge from "./resources/imgs/still/webpage-api_light_large.svg";
import webpageApiLightSmall from "./resources/imgs/still/webpage-api_light_small.svg";
import documentApiAdvancedDarkLarge from "./resources/imgs/still/document-api-advanced_dark_large.svg";
import documentApiAdvancedDarkSmall from "./resources/imgs/still/document-api-advanced_dark_small.svg";
import documentApiAdvancedDefaultLarge from "./resources/imgs/still/document-api-advanced_default_large.svg";
import documentApiAdvancedDefaultSmall from "./resources/imgs/still/document-api-advanced_default_small.svg";
import documentApiAdvancedLightLarge from "./resources/imgs/still/document-api-advanced_light_large.svg";
import documentApiAdvancedLightSmall from "./resources/imgs/still/document-api-advanced_light_small.svg";
import documentApiSimpleDarkLarge from "./resources/imgs/still/document-api-simple_dark_large.svg";
import documentApiSimpleDarkSmall from "./resources/imgs/still/document-api-simple_dark_small.svg";
import documentApiSimpleDefaultLarge from "./resources/imgs/still/document-api-simple_default_large.svg";
import documentApiSimpleDefaultSmall from "./resources/imgs/still/document-api-simple_default_small.svg";
import documentApiSimpleLightLarge from "./resources/imgs/still/document-api-simple_light_large.svg";
import documentApiSimpleLightSmall from "./resources/imgs/still/document-api-simple_light_small.svg";
// ANIMATED
import analysisDarkAnimated from "./resources/imgs/animated/analysis_dark_animated.svg";
import analysisDefaultAnimated from "./resources/imgs/animated/analysis_default_animated.svg";
import analysisLightAnimated from "./resources/imgs/animated/analysis_light_animated.svg";
import dataApiDarkAnimated from "./resources/imgs/animated/data-api_dark_animated.svg";
import dataApiDefaultAnimated from "./resources/imgs/animated/data-api_default_animated.svg";
import dataApiLightAnimated from "./resources/imgs/animated/data-api_light_animated.svg";
import detectionDarkAnimated from "./resources/imgs/animated/detection_dark_animated.svg";
import detectionDefaultAnimated from "./resources/imgs/animated/detection_default_animated.svg";
import detectionLightAnimated from "./resources/imgs/animated/detection_light_animated.svg";
import documentApiDarkAnimated from "./resources/imgs/animated/document-api_dark_animated.svg";
import documentApiDefaultAnimated from "./resources/imgs/animated/document-api_default_animated.svg";
import documentApiLightAnimated from "./resources/imgs/animated/document-api_light_animated.svg";
import takedownDarkAnimated from "./resources/imgs/animated/takedown_dark_animated.svg";
import takedownDefaultAnimated from "./resources/imgs/animated/takedown_default_animated.svg";
import takedownLightAnimated from "./resources/imgs/animated/takedown_light_animated.svg";
import timestampApiDarkAnimated from "./resources/imgs/animated/timestamp-api_dark_animated.svg";
import timestampApiDefaultAnimated from "./resources/imgs/animated/timestamp-api_default_animated.svg";
import timestampApiLightAnimated from "./resources/imgs/animated/timestamp-api_light_animated.svg";
import webForensicsDarkAnimated from "./resources/imgs/animated/web-forensics_dark_animated.svg";
import webForensicsDefaultAnimated from "./resources/imgs/animated/web-forensics_default_animated.svg";
import webForensicsLightAnimated from "./resources/imgs/animated/web-forensics_light_animated.svg";
import webIntelligenceDarkAnimated from "./resources/imgs/animated/web-intelligence_dark_animated.svg";
import webIntelligenceDefaultAnimated from "./resources/imgs/animated/web-intelligence_default_animated.svg";
import webIntelligenceLightAnimated from "./resources/imgs/animated/web-intelligence_light_animated.svg";
import webSignDarkAnimated from "./resources/imgs/animated/web-sign_dark_animated.svg";
import webSignDefaultAnimated from "./resources/imgs/animated/web-sign_default_animated.svg";
import webSignLightAnimated from "./resources/imgs/animated/web-sign_light_animated.svg";
import webTrustDarkAnimated from "./resources/imgs/animated/web-trust_dark_animated.svg";
import webTrustDefaultAnimated from "./resources/imgs/animated/web-trust_default_animated.svg";
import webTrustLightAnimated from "./resources/imgs/animated/web-trust_light_animated.svg";
import webpageApiDarkAnimated from "./resources/imgs/animated/webpage-api_dark_animated.svg";
import webpageApiDefaultAnimated from "./resources/imgs/animated/webpage-api_default_animated.svg";
import webpageApiLightAnimated from "./resources/imgs/animated/webpage-api_light_animated.svg";
import documentApiAdvancedDarkAnimated from "./resources/imgs/animated/document-api-advanced_dark_animated.svg";
import documentApiAdvancedDefaultAnimated from "./resources/imgs/animated/document-api-advanced_default_animated.svg";
import documentApiAdvancedLightAnimated from "./resources/imgs/animated/document-api-advanced_light_animated.svg";
import documentApiSimpleDarkAnimated from "./resources/imgs/animated/document-api-simple_dark_animated.svg";
import documentApiSimpleDefaultAnimated from "./resources/imgs/animated/document-api-simple_default_animated.svg";
import documentApiSimpleLightAnimated from "./resources/imgs/animated/document-api-simple_light_animated.svg";
// export interface ImageSizeCombination {
//     small?: ImageColorCombination;
//     large?: ImageColorCombination;
// }
//
// export interface ImageColorCombination {
//     light?: string;
//     dark?: string;
//     default?: string;
// }
export const APPS = [
    "analysis",
    "data-api",
    "detection",
    "document-api",
    "kopjra",
    "takedown",
    "timestamp-api",
    "web-forensics",
    "web-intelligence",
    "web-sign",
    "web-trust",
    "webpage-api",
    "document-api-advanced",
    "document-api-simple",
];
// export type ImagesType = {
//     [key in typeof APPS[number]]: {
//         still: ImageSizeCombination;
//         animated: ImageColorCombination;
//     };
// };
export const IMAGES = {
    kopjra: {
        still: {
            large: {
                dark: kopjraDarkLarge,
                light: kopjraLightLarge,
                default: kopjraDefaultLarge,
            },
            small: {
                dark: kopjraDarkSmall,
                light: kopjraLightSmall,
                default: kopjraDefaultSmall,
            },
        },
        animated: {
        // not necessary for now
        },
    },
    analysis: {
        still: {
            small: {
                dark: analysisDarkSmall,
                light: analysisLightSmall,
                default: analysisDefaultSmall,
            },
            large: {
                dark: analysisDarkLarge,
                light: analysisLightLarge,
                default: analysisDefaultLarge,
            },
        },
        animated: {
            dark: analysisDarkAnimated,
            light: analysisLightAnimated,
            default: analysisDefaultAnimated,
        },
    },
    "data-api": {
        still: {
            small: {
                dark: dataApiDarkSmall,
                light: dataApiLightSmall,
                default: dataApiDefaultSmall,
            },
            large: {
                dark: dataApiDarkLarge,
                light: dataApiLightLarge,
                default: dataApiDefaultLarge,
            },
        },
        animated: {
            dark: dataApiDarkAnimated,
            light: dataApiLightAnimated,
            default: dataApiDefaultAnimated,
        },
    },
    detection: {
        still: {
            small: {
                dark: detectionDarkSmall,
                light: detectionLightSmall,
                default: detectionDefaultSmall,
            },
            large: {
                dark: detectionDarkLarge,
                light: detectionLightLarge,
                default: detectionDefaultLarge,
            },
        },
        animated: {
            dark: detectionDarkAnimated,
            light: detectionLightAnimated,
            default: detectionDefaultAnimated,
        },
    },
    "document-api": {
        still: {
            small: {
                dark: documentApiDarkSmall,
                light: documentApiLightSmall,
                default: documentApiDefaultSmall,
            },
            large: {
                dark: documentApiDarkLarge,
                light: documentApiLightLarge,
                default: documentApiDefaultLarge,
            },
        },
        animated: {
            dark: documentApiDarkAnimated,
            light: documentApiLightAnimated,
            default: documentApiDefaultAnimated,
        },
    },
    takedown: {
        still: {
            small: {
                dark: takedownDarkSmall,
                light: takedownLightSmall,
                default: takedownDefaultSmall,
            },
            large: {
                dark: takedownDarkLarge,
                light: takedownLightLarge,
                default: takedownDefaultLarge,
            },
        },
        animated: {
            dark: takedownDarkAnimated,
            light: takedownLightAnimated,
            default: takedownDefaultAnimated,
        },
    },
    "timestamp-api": {
        still: {
            small: {
                dark: timestampApiDarkSmall,
                light: timestampApiLightSmall,
                default: timestampApiDefaultSmall,
            },
            large: {
                dark: timestampApiDarkLarge,
                light: timestampApiLightLarge,
                default: timestampApiDefaultLarge,
            },
        },
        animated: {
            dark: timestampApiDarkAnimated,
            light: timestampApiLightAnimated,
            default: timestampApiDefaultAnimated,
        },
    },
    "web-forensics": {
        still: {
            small: {
                dark: webForensicsDarkSmall,
                light: webForensicsLightSmall,
                default: webForensicsDefaultSmall,
            },
            large: {
                dark: webForensicsDarkLarge,
                light: webForensicsLightLarge,
                default: webForensicsDefaultLarge,
            },
        },
        animated: {
            dark: webForensicsDarkAnimated,
            light: webForensicsLightAnimated,
            default: webForensicsDefaultAnimated,
        },
    },
    "web-intelligence": {
        still: {
            small: {
                dark: webIntelligenceDarkSmall,
                light: webIntelligenceLightSmall,
                default: webIntelligenceDefaultSmall,
            },
            large: {
                dark: webIntelligenceDarkLarge,
                light: webIntelligenceLightLarge,
                default: webIntelligenceDefaultLarge,
            },
        },
        animated: {
            dark: webIntelligenceDarkAnimated,
            light: webIntelligenceLightAnimated,
            default: webIntelligenceDefaultAnimated,
        },
    },
    "web-sign": {
        still: {
            small: {
                dark: webSignDarkSmall,
                light: webSignLightSmall,
                default: webSignDefaultSmall,
            },
            large: {
                dark: webSignDarkLarge,
                light: webSignLightLarge,
                default: webSignDefaultLarge,
            },
        },
        animated: {
            dark: webSignDarkAnimated,
            light: webSignLightAnimated,
            default: webSignDefaultAnimated,
        },
    },
    "web-trust": {
        still: {
            small: {
                dark: webTrustDarkSmall,
                light: webTrustLightSmall,
                default: webTrustDefaultSmall,
            },
            large: {
                dark: webTrustDarkLarge,
                light: webTrustLightLarge,
                default: webTrustDefaultLarge,
            },
        },
        animated: {
            dark: webTrustDarkAnimated,
            light: webTrustLightAnimated,
            default: webTrustDefaultAnimated,
        },
    },
    "webpage-api": {
        still: {
            small: {
                dark: webpageApiDarkSmall,
                light: webpageApiLightSmall,
                default: webpageApiDefaultSmall,
            },
            large: {
                dark: webpageApiDarkLarge,
                light: webpageApiLightLarge,
                default: webpageApiDefaultLarge,
            },
        },
        animated: {
            dark: webpageApiDarkAnimated,
            light: webpageApiLightAnimated,
            default: webpageApiDefaultAnimated,
        },
    },
    "document-api-advanced": {
        still: {
            small: {
                dark: documentApiAdvancedDarkSmall,
                light: documentApiAdvancedLightSmall,
                default: documentApiAdvancedDefaultSmall,
            },
            large: {
                dark: documentApiAdvancedDarkLarge,
                light: documentApiAdvancedLightLarge,
                default: documentApiAdvancedDefaultLarge,
            },
        },
        animated: {
            dark: documentApiAdvancedDarkAnimated,
            light: documentApiAdvancedLightAnimated,
            default: documentApiAdvancedDefaultAnimated,
        },
    },
    "document-api-simple": {
        still: {
            small: {
                dark: documentApiSimpleDarkSmall,
                light: documentApiSimpleLightSmall,
                default: documentApiSimpleDefaultSmall,
            },
            large: {
                dark: documentApiSimpleDarkLarge,
                light: documentApiSimpleLightLarge,
                default: documentApiSimpleDefaultLarge,
            },
        },
        animated: {
            dark: documentApiSimpleDarkAnimated,
            light: documentApiSimpleLightAnimated,
            default: documentApiSimpleDefaultAnimated,
        },
    },
};
